module.exports = __webpack_public_path__ + "static/img/coilFlow.94bf72f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coilFlow.png
// module id = 57
// module chunks = 1